import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card-header grid-x align-bottom" }
const _hoisted_2 = { class: "cell large-3 flex-container" }
const _hoisted_3 = { class: "cell large-8 small-offset-1" }
const _hoisted_4 = { class: "body-text-md text-w-bold" }
const _hoisted_5 = { class: "card-content talent-card-info" }
const _hoisted_6 = { class: "data-set" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "data-key text-w-bold" }, "Main Skills:", -1)
const _hoisted_8 = { class: "data-value main-skills-container grid-x" }
const _hoisted_9 = { class: "data-set" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "data-key text-w-bold" }, "Years of experience:", -1)
const _hoisted_11 = { class: "data-value" }
const _hoisted_12 = { class: "data-set" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "data-key text-w-bold" }, "Location:", -1)
const _hoisted_14 = { class: "data-value" }
const _hoisted_15 = { class: "data-set" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "data-key text-w-bold" }, "Hourly rate:", -1)
const _hoisted_17 = { class: "data-value" }
const _hoisted_18 = { class: "grid-x" }
const _hoisted_19 = { class: "cell small-4 position-relative" }
const _hoisted_20 = { class: "height-100 flex-container flex-dir-column align-center-middle" }
const _hoisted_21 = { class: "grid-x flex-dir-column text-center" }
const _hoisted_22 = { class: "cell large-6 small-offset-3" }
const _hoisted_23 = { class: "image-wrap flex-container" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Profile Details", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "card-divider" }, null, -1)
const _hoisted_26 = { class: "cell small-4 card-content talent-card-info" }
const _hoisted_27 = { class: "data-set" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "data-key text-w-bold" }, "About the candidate:", -1)
const _hoisted_29 = { class: "data-value text-transform-none" }
const _hoisted_30 = { class: "data-set" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "data-key text-w-bold" }, "Main Skills:", -1)
const _hoisted_32 = { class: "data-value main-skills-container grid-x" }
const _hoisted_33 = { class: "data-set" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "data-key text-w-bold" }, "Complementary Skills:", -1)
const _hoisted_35 = { class: "data-value main-skills-container grid-x" }
const _hoisted_36 = { class: "cell small-4 card-content talent-card-info" }
const _hoisted_37 = { class: "data-set" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "data-key text-w-bold" }, "Experience:", -1)
const _hoisted_39 = { class: "data-value text-transform-none" }
const _hoisted_40 = { class: "data-set" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "data-key text-w-bold" }, "Years of experience:", -1)
const _hoisted_42 = { class: "data-value" }
const _hoisted_43 = { class: "data-set" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "data-key text-w-bold" }, "Location:", -1)
const _hoisted_45 = { class: "data-value" }
const _hoisted_46 = { class: "grid-x flex-y-end" }
const _hoisted_47 = { class: "cell auto" }
const _hoisted_48 = { class: "data-set" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "data-key text-w-bold" }, "Hourly rate:", -1)
const _hoisted_50 = { class: "data-value" }
const _hoisted_51 = { class: "cell auto" }


import { NCard, NImage, NTag, NButton, NIcon } from 'naive-ui'
import { ChevronLeftRound } from '@vicons/material'
import { getImgUrl } from '@/ts/helpers'
import { TalentProfileProps } from "@/ts/interfaces";


export default /*#__PURE__*/_defineComponent({
  __name: 'TalentProfileCard',
  props: {
    isExpanded: { type: Boolean },
    profilePicLink: {},
    name: {},
    profileLink: {},
    mainSkills: {},
    yearsOfExperience: {},
    location: {},
    hourlyRate: {},
    about: {},
    complementarySkills: {},
    experience: {}
  },
  emits: ['expandCard', 'closeCard'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const experienceYearsText = props.yearsOfExperience > 1 ? 'Years' : 'Year'

const emit = __emit

const expandCard = () => emit('expandCard')

const closeCard = () => emit('closeCard')


return (_ctx: any,_cache: any) => {
  return (!_ctx.isExpanded)
    ? (_openBlock(), _createBlock(_unref(NCard), {
        key: 0,
        size: "large",
        class: "talent-card"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(NImage), {
                src: _unref(getImgUrl)(_ctx.profilePicLink)
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.name), 1),
              _createElementVNode("a", {
                class: "simple-link",
                onClick: expandCard
              }, "View profile")
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainSkills, (skill, key) => {
                  return (_openBlock(), _createBlock(_unref(NTag), {
                    key: key,
                    type: "info",
                    bordered: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(skill), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.yearsOfExperience) + " " + _toDisplayString(_unref(experienceYearsText)), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.location), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("p", _hoisted_17, "$" + _toDisplayString(_ctx.hourlyRate) + " USD", 1)
            ])
          ]),
          _createVNode(_unref(NButton), {
            type: "primary",
            focusable: false,
            size: "large",
            onClick: expandCard
          }, {
            default: _withCtx(() => [
              _createTextVNode(" VIEW PROFILE ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_unref(NCard), {
        key: 1,
        size: "large",
        class: "talent-card expanded"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_unref(NImage), {
                        width: "100%",
                        src: _unref(getImgUrl)(_ctx.profilePicLink)
                      }, null, 8, ["src"])
                    ])
                  ]),
                  _createElementVNode("p", null, _toDisplayString(_ctx.name), 1),
                  _hoisted_24
                ])
              ]),
              _hoisted_25
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.about), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("p", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainSkills, (skill, key) => {
                    return (_openBlock(), _createBlock(_unref(NTag), {
                      key: key,
                      type: "info",
                      bordered: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(skill), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("p", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainSkills, (skill, key) => {
                    return (_openBlock(), _createBlock(_unref(NTag), {
                      key: key,
                      type: "info",
                      bordered: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(skill), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experience, (job, index) => {
                    return (_openBlock(), _createElementBlock("ul", { key: index }, [
                      _createElementVNode("li", null, _toDisplayString(job.job_position), 1),
                      _createElementVNode("li", null, "(" + _toDisplayString(job.time_period) + ")", 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.yearsOfExperience) + " " + _toDisplayString(_unref(experienceYearsText)), 1)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.location), 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _createElementVNode("p", _hoisted_50, "$" + _toDisplayString(_ctx.hourlyRate) + " USD", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("a", {
                    class: "simple-link flex-container align-center-middle font-style-normal text-transform-none",
                    onClick: _withModifiers(closeCard, ["prevent"])
                  }, [
                    _createVNode(_unref(NIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ChevronLeftRound))
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" Back ")
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }))
}
}

})